












































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {LadingPaymentType} from "@/enums/type";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import ExpenseCustomerTable
    from "@/modules/receiptsexpenses/expensecustomer/List/components/ExpenseCustomerTable/index.vue";
import {ExpenseCustomerParams} from "@/modules/receiptsexpenses/expensecustomer/params";
import {ExpenseCustomerStore} from "@/modules/receiptsexpenses/expensecustomer/store";
import {allCreditCustomer} from "@/modules/receiptsexpenses/expensecustomer/services";
import TableToExcel from "@linways/table-to-excel";
import ExpenseCustomerExcel
    from "@/modules/receiptsexpenses/expensecustomer/List/components/ExpenseCustomerExcel/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";

@Component({
    name: "CreditCustomer",
    components: {ExpenseCustomerExcel, ExpenseCustomerTable, LadingPaymentTypeLabel, LadingStatusLabel, CustomerSelector, MillisecondDatePicker}
})
export default class extends mixins(CommonMixin) {
    params: ExpenseCustomerParams = new ExpenseCustomerParams();
    LadingPaymentType = LadingPaymentType;
    debtsCustomerExcel = [] as any;
    isExporting = false;

    created() {
        ExpenseCustomerStore.updateParamsExpenseCustomer(this.params);
        ExpenseCustomerStore.listCreditCustomer(ExpenseCustomerStore.params);
    }

    @Watch("params", {deep: true})
    onChangeParams(val: any) {
        ExpenseCustomerStore.updateParamsExpenseCustomer({...val, page: 1});
        ExpenseCustomerStore.listCreditCustomer(ExpenseCustomerStore.params);
    }

    get creditCustomers() {
        return ExpenseCustomerStore.ids.map((id: number) => ExpenseCustomerStore.data[id]);
    }

    async exportExcel() {
        try {
            await this.getDataExport();
            setTimeout(() => {
                TableToExcel.convert(document.getElementById("table-excel-expense-customer"), {
                    name: `Danh sách trả khách hàng.xlsx`,
                    sheet: {
                        name: "Sheet 1"
                    }
                });
            }, 200)
        } catch (e) {
        }
    }

    async getDataExport() {
        try {
            this.isExporting = true;
            const { data } = await allCreditCustomer(ExpenseCustomerStore.params);
            this.debtsCustomerExcel = data.datas;
            console.log(this.debtsCustomerExcel)
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xuất excel lỗi");
        } finally {
            this.isExporting = false;
        }
    }
}
